exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.className[data-v-7751e2eb]{width:100%;height:inherit;padding:5px\n}\n.class-name-icon[data-v-7751e2eb]{font-size:14px;line-height:2em;margin:0 5px\n}\n.table-operations[data-v-7751e2eb]{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.operation-icon[data-v-7751e2eb]{font-size:20px;margin:0 5px\n}", ""]);

// exports
